import axios from "axios";
import { baseUrlOtodis, xApiKeyOtodis } from "../../config/api/apiConfig";

class StockApiService {
  private axios = axios.create({
    baseURL: baseUrlOtodis,
  });

  private axiosGCF = axios.create({
    baseURL: "https://asia-southeast1-autotrimitra.cloudfunctions.net",
  });

  public setToken(token: string) {
    this.axios.defaults.headers.common["Authorization"] = "Bearer " + token;
  }

  public async getStock(params?: {
    vehicleEngineNumber?: string;
    dealerCode?: string;
    stockUnitCode?: string;
    vehicleYear?: number;
    statusStock?: string;
    vehicleColorCode?: string;
    vehicleVariantCode?: string;
    warehouseCode?: string | null;
    liteRespone?: boolean;
  }) {
    const queries = {
      ...(params?.dealerCode && {
        dealer_code: params.dealerCode,
      }),
      ...(params?.vehicleEngineNumber && {
        vehicle_engine_number: params.vehicleEngineNumber,
      }),
      ...(params?.stockUnitCode && {
        stock_unit_code: params.stockUnitCode,
      }),
      ...(params?.vehicleYear && {
        vehicle_year: params.vehicleYear,
      }),
      ...(params?.statusStock && {
        status_stock: params.statusStock,
      }),
      ...(params?.warehouseCode && {
        warehouse_code: params.warehouseCode,
      }),
      ...(params?.vehicleVariantCode && {
        vehicle_variant_code: params.vehicleVariantCode,
      }),
      ...(params?.vehicleColorCode && {
        vehicle_color_code: params.vehicleColorCode,
      }),
      ...(params?.liteRespone && {
        lite_respone: params.liteRespone,
      }),
    };
    try {
      return await this.axios.get<any>("/stock", {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
        params: {
          ...queries,
        },
      });
    } catch (e: any) {
      console.log(e?.response?.data?.error?.message);

      throw new Error(e?.response?.data?.error?.message ?? "Error Kode Nomor Mesin Tidak Ditemukan");
    }
  }

  public async changeWarehouseStock(inputData?: any) {
    try {
      return await this.axios.put<any>("/stock/change-warehouse", inputData, {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
          "Content-Type": "application/json",
        },
      });
    } catch (e: any) {
      console.log(e);
      throw new Error(e);
    }
  }
}

export const stockApiService = new StockApiService();
